import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

export const saftCodeSchema = new schema.Entity('saftCodes');

export const saftCodes = configureApiEntity('SAFTCODES', 'saftcodes', saftCodeSchema);
